var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-orange mb-2",class:_vm.disabled ? 'btn-disabled': '',on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"mdi mdi-plus-thick"}),_vm._v(" Save ")])
}
var staticRenderFns = []

export { render, staticRenderFns }